module.exports = __webpack_public_path__ + "static/volunteer_profile1@2x-7f8c99f4f794c76747dcef9446049571.png";